import { Partner } from '@features/ForestOwner/EditShareOwnership/Partner/Partner'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'

export const Route = createFileRoute(
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/',
)({
  component: RouteComponent,
  staticData: {
    breadcrumb: t('forestowner-editshareownership-partner.pageTitle'),
  },
})

function RouteComponent() {
  return <Partner />
}
